export default [
    {
        path: '/',
        redirect: {
            name: 'index'
        },
        component: resolve => require(['views/index'], resolve),
        children: [
            {
                name: 'index',
                path: 'index',
                meta: {
                    hideMainHeader: false
                },
                component: resolve => require(['views/home'], resolve)
            },
            {
                name: 'user-cart',
                path: 'cart',
                meta: {
                    name: '我的购物车',
                    hideMainHeader: true
                },
                component: resolve => require(['views/user/user-cart'], resolve)
            },
            {
                name: 'user-invoice',
                path: 'user-invoice',
                meta: {
                    name: '增票资质',
                    hideMainHeader: true
                },
                component: resolve => require(['views/user/user-invoice'], resolve)
            },
            {
                name: 'user-coupon',
                path: 'user-coupon',
                meta: {
                    name: '优惠券收支明细',
                    hideMainHeader: true
                },
                component: resolve => require(['views/user/user-coupon'], resolve)
            },
            {
                name: 'user-security',
                path: 'user-security',
                meta: {
                    name: '账号安全',
                    hideMainHeader: true
                },
                component: resolve => require(['views/user/user-security'], resolve)
            },
            {
                name: 'user-address',
                path: 'user-address',
                meta: {
                    name: '地址管理',
                    hideMainHeader: true
                },
                component: resolve => require(['views/user/user-address'], resolve)
            },
            {
                name: 'order-confirm',
                path: 'confirm',
                meta: {
                    name: '订单确认',
                    hideMainHeader: true
                },
                component: resolve => require(['views/order/confirm'], resolve)
            },
            {
                name: 'order-payment',
                path: 'payment',
                meta: {
                    name: '支付订单',
                    requestAuth: true,
                    hideMainHeader: true,
                    hideMainFooter: true
                },
                component: resolve => require(['views/order/payment'], resolve)
            },
            {
                name: 'goods-detail',
                path: 'goods-detail',
                meta: {
                    name: '商品详情',
                    hideMainHeader: true
                },
                component: resolve => require(['views/goods/goods-detail'], resolve)
            },
            {
                name: 'goods-list',
                path: 'list',
                meta: {
                    name: '系统商品',
                    hideMainHeader: true
                },
                component: resolve => require(['views/goods/goods-list'], resolve)
            },
            {
                name: 'discount-list',
                path: 'discount-list',
                meta: {
                    name: '优惠专区',
                    hideMainHeader: true
                },
                component: resolve => require(['views/goods/discount-list'], resolve)
            },
            {
                name: 'goods-activity',
                path: 'goods-activity',
                meta: {
                    name: '特殊商品',
                    hideMainHeader: true
                },
                component: resolve => require(['views/goods/goods-activity'], resolve)
            },
            {
                name: 'order-detail',
                path: 'orderDetail',
                meta: {
                    name: '订单详情',
                    requestAuth: true,
                    hideMainHeader: true
                },
                component: resolve => require(['views/order/detail'], resolve)
            },
            {
                name: 'oper-result',
                path: 'result',
                meta: {
                    name: '操作结果',
                    hideMainHeader: true
                },
                component: resolve => require(['views/result'], resolve)
            },
            {
                name: 'user-center',
                path: 'center',
                meta: {
                    name: '个人中心',
                    hideMainHeader: true
                },
                component: resolve => require(['views/user/user-center'], resolve)
            },
            {
                name: 'user-center-update',
                path: 'updateUserInfo',
                meta: {
                    name: '账号信息',
                    hideMainHeader: true
                },
                component: resolve => require(['views/user/user-center-update'], resolve)
            },
            {
                name: 'user-order',
                path: 'order',
                meta: {
                    name: '订单管理',
                    hideMainHeader: true
                },
                component: resolve => require(['views/user/user-order'], resolve)
            },
            {
                name: 'user-pass-update',
                path: 'updateUserPwd',
                meta: {
                    name: '修改密码',
                    hideMainHeader: true
                },
                component: resolve => require(['views/user/user-pass-update'], resolve)
            },
            {
                name: 'about',
                path: 'aboutMe',
                meta: {
                    name: '关于UIOT',
                    hideMainHeader: true
                },
                component: resolve => require(['views/about'], resolve)
            },
            {
                name: 'login',
                path: 'login',
                meta: {
                    name: '登录',
                    hideMainHeader: false
                },
                component: resolve => require(['views/login'], resolve)
            },
            {
                name: 'regist',
                path: 'regist',
                meta: {
                    name: '注册',
                    hideMainHeader: true
                },
                component: resolve => require(['views/regist'], resolve)
            },
            {
                name: 'forgetPwd',
                path: 'forgetPwd',
                meta: {
                    name: '忘记密码',
                    hideMainHeader: true
                },
                component: resolve => require(['views/forgetPwd'], resolve)
            },
            {
                name: 'order-customMade',
                path: 'order-customMade',
                meta: {
                    name: '定制产品',
                    hideMainHeader: true
                },
                component: resolve => require(['views/order/customMade'], resolve)
            },
            {
                name: 'activity-list',
                path: 'activity-list',
                meta: {
                    name: '商品列表',
                    hideMainHeader: true
                },
                component: resolve => require(['views/activity/activity-list'], resolve)
            },
            {
                name: 'activity-product-detail',
                path: 'activity-product-detail',
                meta: {
                    name: '活动产品详情',
                    hideMainHeader: true
                },
                component: resolve => require(['views/activity/activity-product-detail'], resolve)
            },
            {
                name: 'activity-confirm',
                path: 'activity-confirm',
                meta: {
                    name: '活动下单',
                    hideMainHeader: true
                },
                component: resolve => require(['views/activity/activity-confirm'], resolve)
            },
            {
                name: 'pay-result',
                path: 'pay-result',
                meta: {
                    name: '支付成功',
                    hideMainHeader: true,
                    hideMainFooter: true
                },
                component: resolve => require(['views/order/payResult'], resolve)
            },
            {
                name: 'deliver',
                path: 'deliver',
                meta: {
                    name: '物流信息',
                    hideMainHeader: true
                },
                component: resolve => require(['views/deliver/index'], resolve)
            }
        ]
    },
    {
        name: 'error',
        path: '*',
        redirect: {
            name: '404'
        },
        component: resolve => require(['views/error/404'], resolve)
    }
]



// WEBPACK FOOTER //
// ./src/router/index.js